import { graphql } from '@/gql';
import type { CoachingAgentsQuery } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type CoachingAgent = CoachingAgentsQuery['agents'][number];

export const fetchCoachingAgents = async (): Promise<CoachingAgent[]> => {
  const response = await queryExecute({
    query: graphql(`
      query CoachingAgents($type: String) {
        agents(kind: $type) {
          id
          name
          displayName
        }
      }
    `),
    variables: { type: 'coaching-qa' },
  });

  return response.data.agents;
};
